export default __webpack_public_path__ + "assets/small-pin-selected.c9d56f84.svg";